export enum UserLogs {
  INDEX = '/user-logs',
}
